import { RecruitersActionTypes, RecruitersState, READ_RECRUITER_DROPDOWN_DATA_REQUEST, READ_RECRUITER_DROPDOWN_DATA_SUCCESS, READ_RECRUITER_DROPDOWN_DATA_FAILURE } from "store/reducers/types/dashboard/recruiters";

const defaultState: RecruitersState = {
  isLoading: false,
  errorMessage: ""
};

export default function recruiters(state = defaultState, action: RecruitersActionTypes): RecruitersState {
  switch (action.type) {
    case READ_RECRUITER_DROPDOWN_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case READ_RECRUITER_DROPDOWN_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: "",
      };
    case READ_RECRUITER_DROPDOWN_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
      };
    default:
      return state;
  }
}
